import React from 'react';
import styled from '@emotion/styled';

import { MEMBERSHIP_PATHNAME } from '~/src/common/routes';
import { navigate } from '~/src/common/utilities';
import { breakpoints, fontWeight } from '~/src/styles';

import { orangeButtonStyles, whiteOutlineButtonStyles } from './elements';

const SubmittedFormTitle = styled.div`
  font-size: 18px;
  ${breakpoints.minTabletLandscape} {
    font-size: 20px;
  }
  font-weight: ${fontWeight.bold};
  line-height: 28px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 32px;
`;

const SubmittedFormText = styled.div`
  font-size: 18px;
  ${breakpoints.minTabletLandscape} {
    font-size: 20px;
  }
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 24px;
`;

const RedirectToSignUpButton = styled.button`
  ${orangeButtonStyles}

  ${breakpoints.minTabletLandscape} {
    flex: 1;
  }
`;

const CloseModalButton = styled.button`
  ${whiteOutlineButtonStyles}

  ${breakpoints.minTabletLandscape} {
    flex: 1;
  }
`;

const ButtonsGroup = styled.div`
  display: flex;
  gap: 22px;
  flex-direction: column;

  ${breakpoints.minTabletLandscape} {
    flex-direction: row;
  }
`;

const Container = styled.div`
  padding-bottom: 10px;
  ${breakpoints.minTabletLandscape} {
    padding-bottom: 32px;
  }
`;

interface Props {
  onClose: () => void;
}
export const SubmittedFormBody: React.FC<Props> = ({ onClose }) => {
  const redirectToSignUp = () => {
    navigate(MEMBERSHIP_PATHNAME);
  };
  return (
    <Container>
      <SubmittedFormTitle>
        Great!
        <br />
        The link to your ebook has been sent to your inbox.
      </SubmittedFormTitle>
      <SubmittedFormText>
        Would you like to try Yoga International free for 7 days?
      </SubmittedFormText>
      <ButtonsGroup>
        <RedirectToSignUpButton onClick={redirectToSignUp}>Yes please</RedirectToSignUpButton>
        <CloseModalButton onClick={onClose}>Not right now</CloseModalButton>
      </ButtonsGroup>
    </Container>
  );
};
